/** Profile → category mapping and display labels, shared between server and UI. */

import type { WebMcpProfile } from "@gotts.ai/mcp";

/** Profile → included categories mapping. */
export const PROFILE_CATEGORIES: Record<WebMcpProfile, Set<string>> = {
  "webenv-data": new Set([
    "data",
    "intelligence",
    "fees",
    "utility",
    "environment",
  ]),
  "webenv-trader": new Set([
    "data",
    "intelligence",
    "fees",
    "utility",
    "environment",
    "trading",
    "safety",
    "chain-controls",
  ]),
  "webenv-lp": new Set([
    "data",
    "intelligence",
    "fees",
    "utility",
    "environment",
    "trading",
    "safety",
    "chain-controls",
    "lp",
    "scenarios",
    "state",
  ]),
  "webenv-full": new Set([
    "data",
    "intelligence",
    "fees",
    "utility",
    "environment",
    "trading",
    "safety",
    "chain-controls",
    "lp",
    "scenarios",
    "state",
    "erc8004",
    "memory",
    "self-improvement",
    "dashboard",
    "session-keys",
    "wallet",
    "testnet",
  ]),
  "webenv-dev": new Set([
    "data",
    "intelligence",
    "fees",
    "utility",
    "environment",
    "trading",
    "safety",
    "chain-controls",
    "lp",
    "scenarios",
    "state",
    "erc8004",
    "memory",
    "self-improvement",
    "dashboard",
    "stubs",
    "streaming",
    "session-keys",
    "wallet",
    "testnet",
  ]),
};

/** Human-readable labels for tool categories. */
export const CATEGORY_LABELS: Record<string, string> = {
  "chain-controls": "Chain Controls",
  dashboard: "Dashboard",
  data: "Data",
  environment: "Environment",
  erc8004: "ERC-8004",
  fees: "Fees",
  intelligence: "Intelligence",
  lp: "Liquidity",
  memory: "Memory",
  safety: "Safety",
  scenarios: "Scenarios",
  "self-improvement": "Self-Improvement",
  state: "State",
  streaming: "Streaming",
  stubs: "Stubs",
  trading: "Trading",
  utility: "Utility",
};
